import React from "react";
import Autenticacion from "../components/Login";

function LoginPage() {
    return (
        <Autenticacion />
    )
}

export default LoginPage;